import React, { useMemo } from 'react';
import Table from '../Table';
import SearchTable from '../SearchTable';

export default function Championships(props) {
    const columns = useMemo(
        () => [
            {
                Header: 'Season',
                accessor: 'season',
                Cell: props => <p className="database-table__subtitle proxima"><a href={props.row.original.url}>{props.value}</a></p>,
            },
            {
                Header: 'Championship',
                accessor: 'title',
                Cell: props => <p className="database-table__title"><a href={props.row.original.url}>{props.value}</a></p>,
            },
            {
                Header: 'Series',
                accessor: 'series',
                only_desktop: true,
                Cell: props => <p className="database-table__title"><a href={props.row.original.series_url}>{props.value}</a></p>,
            },
            {
                Header: 'Champions',
                accessor: 'race_winner',
                Cell: props => (
                    props.value.map((value, index) => {
                        if (value.url !== '') {
                            return <p className={value.css_class} key={index}><a href={value.url}>{value.name}</a></p>;
                        } else {
                            return <p className={value.css_class} key={index}>{value.name}</p>;
                        }
                    })
                ),
            },
        ],
        [],
    );

    const TableComponent = props.searchTable ? SearchTable : Table;

    return <TableComponent columns={columns} {...props} />;
}
